import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IAccess, IUserData } from '@shared/models';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ILoginRequest } from 'src/app/modules/login/model/Loging';
import { UserService } from '../user/user.service';
import { AuthApiService } from './auth.api.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { USER_INFO_LOCAL_STORAGE_KEY } from '@shared/utils/constant';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _authApiService = inject(AuthApiService);
  private readonly _userService = inject(UserService);
  private readonly _router = inject(Router);

  login(data: ILoginRequest): Observable<IUserData> {
    return this._authApiService.login(data).pipe(
      tap((res: HttpResponse<any>) => {
        // const token = res.headers.get('Authorization'); // adjust header name if needed
        const userData = res.body?.data;

        if (userData) {
          this._userService.setLoggedInUser(userData.tUser);
          localStorage.setItem('access_token', userData.sAccessToken);
          localStorage.setItem(
            USER_INFO_LOCAL_STORAGE_KEY,
            JSON.stringify(userData),
          );
          // const currentOrgId = (
          //   (userData.tUserDetails as IUserDetails)
          //     .tOrganization as IOrganization
          // )?._id;
          // if (currentOrgId) {
          //   localStorage.setItem('cuOrg', currentOrgId);
          // }
        }
      }),
      map((res) => res.body.data),
    );
  }

  setLogin(userInfoRes: any) {
    this._userService.setLoggedInUser(userInfoRes.tUser);
    localStorage.setItem(
      USER_INFO_LOCAL_STORAGE_KEY,
      JSON.stringify(userInfoRes),
    );
  }

  logout(): void {
    localStorage.removeItem(USER_INFO_LOCAL_STORAGE_KEY);
    this._userService.setLoggedInUser(null);
    this.sendToLogout();
  }

  loadUserDetails(token: string): Observable<any> {
    return this._authApiService.getUserByToken(token);
  }

  hasBgVerifyAccess(): boolean {
    try {
      const userInfo = this.getCurrentUserInfo();
      const tags: IAccess[] = userInfo?.tUserAccess ?? [];
      return tags.some(
        (t) =>
          (t.sTag === 'atTagUniversalAccess' ||
            t.sTag === 'atTagbg' ||
            t.sTag === 'atTagBackgroundAccess') &&
          (t.bCanView || t.bCanWrite)
      );
    } catch {
      return false;
    }
  }

  public getCurrentUserInfo() {
    try {
      const usrStr = localStorage.getItem(USER_INFO_LOCAL_STORAGE_KEY);
      if (usrStr) return JSON.parse(usrStr);
      else return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public isStudentUser(): boolean {
    try {
      const tUser = this.getCurrentUserInfo()?.tUser;
      if (!tUser) return false;
      const role = tUser?.tRole;
      const roleId =
        typeof role === 'string' ? role : (role as any)?._id;
      return !roleId && !tUser?.tUserDetails;
    } catch {
      return false;
    }
  }

  sendToAuth() {
    localStorage.removeItem(USER_INFO_LOCAL_STORAGE_KEY);
    const url = `${environment.authUrl}?redirect-url=${document.location.origin}/auth`;
    document.location.href = url;
  }

  sendToAuthManager() {
    this._router.navigate(['/auth']);
  }

  sendToLogout() {
    const url = `${environment.authUrl}/logout?redirect-url=${document.location.href}`;
    document.location.href = url;
  }

  getLocalRedirectUrl(): string | null {
    return localStorage.getItem('redirectUrl') || null;
  }

  setLocalRedirectUrl(url: string) {
    localStorage.setItem('redirectUrl', url == '/auth' ? '/' : url);
  }

  removeLocalRedirectUrl() {
    localStorage.removeItem('redirectUrl');
  }
}
